import * as React from 'react';

import Card from '../Card/Card';
import HeaderInfoTooltip from '../HeaderInfoTooltip/HeaderInfoTooltip';

import { capitalize } from '../../utils/utils';

const ListWidget = ({
  data,
  leftHeading,
  rightHeading,
  leftHeadingTooltip,
  rightHeadingTooltip,
  title,
  emptyStateMessage,
  isLoading,
  subtitle,
  columns = 1,
  rows,
  className,
  textFormatter,
  valueFormatter,
  onDataClick,
  ...otherProps
}) => {
  rows = rows || Math.ceil(data.length / columns);
  return (
    <Card
      {...otherProps}
      className={['ListWidget', className].filter((f) => !!f).join(' ')}
      title={title}
      subtitle={subtitle}
      emptyStateMessage={emptyStateMessage}
      isEmpty={!data || (Array.isArray(data) && !data.length)}
      isLoading={isLoading}
      {...otherProps}>
      <div className="list-widget-container">
        {Array.from(Array(columns).keys()).map((col, i) => (
          <div key={'col' + col} className="column">
            {(!!leftHeading || !!rightHeading) && (
              <div className="heading">
                <HeaderInfoTooltip content={leftHeadingTooltip}>
                  <span>{leftHeading}</span>
                </HeaderInfoTooltip>
                <HeaderInfoTooltip content={rightHeadingTooltip}>
                  <span>{rightHeading}</span>
                </HeaderInfoTooltip>
              </div>
            )}
            {Array.from(Array(rows).keys()).map((row) => (
              <div key={'row' + col + row} className="row">
                <Row
                  onDataClick={onDataClick}
                  col={col}
                  row={row}
                  count={rows}
                  data={data}
                  textFormatter={textFormatter}
                  valueFormatter={valueFormatter}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </Card>
  );
};

const Row = ({
  row,
  col,
  data,
  textFormatter,
  valueFormatter,
  count,
  onDataClick
}) => {
  const dataEntry = (data && data[col * count + row]) || {};
  return (
    <React.Fragment>
      {(!onDataClick && (
        <span
          onClick={
            typeof dataEntry.onClick === 'function' ? dataEntry.onClick : null
          }
          className={
            (!!dataEntry.onClick && !!dataEntry.text && 'clickable') || ''
          }>
          {typeof textFormatter === 'function'
            ? textFormatter(dataEntry.text)
            : dataEntry.text}
        </span>
      )) || (
        <span
          onClick={() =>
            typeof onDataClick === 'function' && onDataClick(dataEntry.text)
          }
          className={(!!onDataClick && !!dataEntry.text && 'clickable') || ''}>
          {typeof textFormatter === 'function'
            ? textFormatter(dataEntry.text)
            : dataEntry.text}
        </span>
      )}
      <span>
        {typeof valueFormatter === 'function'
          ? valueFormatter(dataEntry.value)
          : dataEntry.value}
      </span>
    </React.Fragment>
  );
};

export default ListWidget;
